<template>
  <div class="padding-10">
    <FilterBar ref="filter"></FilterBar>
    <job-search></job-search>
    <Table @onDispatched="onDispatched" @onJobRemove="onJobRemove"></Table>
  </div>
</template>

<script>
// import customerModal from "../assets/js/customer.modal";
// import { customers } from "../assets/js/firebase";
import FilterBar from "../components/jobs/Filter.vue";
import JobSearch from "../components/jobs/JobSearch.vue";
import Table from "../components/jobs/Table.vue";
// import { importCustomer } from "../assets/js/import.template.js";
// import { customers } from "../assets/js/firebase";
export default {
  components: {
    FilterBar,
    Table,
    JobSearch,
  },
  methods: {
    onDispatched() {
      this.$refs.filter.fetch();
    },
    onJobRemove() {
      this.$refs.filter.fetch();
    },
  },
  mounted() {
    // customers.get().then(snap => {
    //   snap.forEach(doc => {
    //     let { fields } = doc.data();
    //     let taxAmount = 0;
    //     let tax = fields[customerModal.TAX];
    //     if (tax) {
    //       taxAmount = tax / 0.0775;
    //     }
    //     fields[customerModal.TAXABLE_AMOUNT] = taxAmount.toFixed(2);
    //     console.log(fields);
    //     doc.ref.update({
    //       fields
    //     });
    //     console.log("taxable amount", taxAmount);
    //   });
    // });
  },
};
</script>

<style></style>
